import React, { FC } from 'react';

import OverlayListItem from './OverlayListItem';

export interface OverlayListProps {
  items: string[] | number[];
  selectedItem: string | number;
  onItemClick: (item: string | number) => void;
}

const OverlayList: FC<OverlayListProps> = ({
  items,
  selectedItem,
  onItemClick,
}: OverlayListProps) => {
  return (
    <ul className="flex flex-col list-none max-h-screen overflow-y-auto w-full">
      {items.map((item) => (
        <OverlayListItem
          key={item}
          item={item}
          onClick={onItemClick}
          isSelected={selectedItem === item}
        />
      ))}
    </ul>
  );
};

export default OverlayList;
